import React, { useState } from 'react';
import { toast } from 'sonner';
import { api, formatApiError } from '@/lib/api';
import { AUTH } from '@/constants/testIds';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Loader2 } from 'lucide-react';

export default function ChangePasswordPage() {
    const [cur, setCur] = useState('');
    const [next, setNext] = useState('');
    const [loading, setLoading] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await api.post('/auth/change-password', {
                current_password: cur,
                new_password: next,
            });
            toast.success('Password updated');
            setCur('');
            setNext('');
        } catch (err) {
            toast.error(formatApiError(err));
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="max-w-lg">
            <h1 className="font-display text-3xl sm:text-4xl font-black tracking-tight mt-1">
                Change password
            </h1>
            <p className="text-sm text-muted-foreground mt-2 mb-8">
                Sessions on other devices will remain active.
            </p>
            <form onSubmit={submit} className="space-y-5 rounded-sm border border-border bg-card p-6">
                <div className="space-y-2">
                    <Label className="text-sm">Current password</Label>
                    <Input
                        type="password"
                        required
                        value={cur}
                        onChange={(e) => setCur(e.target.value)}
                        data-testid={AUTH.change.currentInput}
                        className="rounded-sm h-11"
                    />
                </div>
                <div className="space-y-2">
                    <Label className="text-sm">New password</Label>
                    <Input
                        type="password"
                        required
                        minLength={6}
                        value={next}
                        onChange={(e) => setNext(e.target.value)}
                        data-testid={AUTH.change.newInput}
                        className="rounded-sm h-11"
                    />
                </div>
                <Button
                    type="submit"
                    disabled={loading}
                    data-testid={AUTH.change.submitButton}
                    className="rounded-sm"
                >
                    {loading ? <><Loader2 className="animate-spin mr-2" size={16} />Saving…</> : 'Update password'}
                </Button>
            </form>
        </div>
    );
}
